import parentDelete from '@/store/modules/parents/parents-delete'

export default {
  parentDelete
}
